"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

exports.email = email;
exports.businessId = businessId;
exports.required = required;
exports.requiredIf = requiredIf;
exports.minLength = minLength;
exports.maxLength = maxLength;
exports.matchPasswords = matchPasswords;
exports.number = number;
exports.integer = integer;
exports.createValidator = createValidator;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isEmpty = function isEmpty(value) {
  return value === undefined || value === null || value === "";
};
var join = function join(rules) {
  return function (value, data) {
    return rules.map(function (rule) {
      return rule(value, data);
    }).filter(function (error) {
      return !!error;
    })[0 /* first error */];
  };
}; // eslint-disable-line

function email(value) {
  if (!isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return "Virheellinen sähköpostiosoite";
  }
}

function businessId(value) {
  if (!isEmpty(value) && !/^[0-9]{7}-[0-9]{1}$/i.test(value)) {
    return "Anna muodossa 1234567-8";
  }
}

function required(value) {
  if (isEmpty(value)) {
    return "Pakollinen tieto";
  }
}

function requiredIf(field, testValue) {
  return function (value, data) {
    if (data && data[field] === testValue) {
      return required(value);
    }
  };
}

function minLength(min) {
  return function (value) {
    if (!isEmpty(value) && value.length < min) {
      return "Sy\xF6t\xE4 v\xE4hint\xE4\xE4n " + min + " merkki\xE4";
    }
  };
}

function maxLength(max) {
  return function (value) {
    if (!isEmpty(value) && value.length > max) {
      return "Sy\xF6t\xE4 enint\xE4\xE4n " + max + " merkki\xE4";
    }
  };
}

function matchPasswords(field) {
  return function (value, data) {
    if (data) {
      if (value !== data[field]) {
        return "Salasanat eivät täsmää";
      }
    }
  };
}

function number(value) {
  if (!isEmpty(value) && !isNumeric(value)) {
    return "T\xE4ytyy olla numero";
  }
}

function integer(value) {
  if (!isEmpty(value) && !isInt(value)) {
    return "T\xE4ytyy olla tasaluku";
  }
}

function createValidator(rules) {
  return function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var errors = {};
    (0, _keys2.default)(rules).forEach(function (key) {
      var rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
      var error = rule(data[key], data);
      if (error) {
        errors[key] = error;
      }
    });
    return errors;
  };
}

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function isInt(value) {
  return !isNaN(value) && function (x) {
    return (x | 0) === x;
  }(parseFloat(value));
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/validation.js
 ** module id = 54
 ** module chunks = 0
 **/